// React imports
import { useEffect } from "react";

// Components
import Container from "../components/Container.tsx";
import ScrollToTop from "../components/ScrollToTop.tsx";

// Contextes
import { useInTheGame } from "../utils/InTheGameContexte.tsx";

// Data
import { generalReglesData, modesReglesData } from "../data/regles.ts";

// Librairies
import ReactMarkdown from "react-markdown";

function Regles() {
  const mode = ["Entraînement", "Classique", "Expert"];
  // const [showScrollButton, setShowScrollButton] = useState(false);

  // Toggle Game
  const { toggleGame } = useInTheGame();
  useEffect(() => {
    toggleGame(true);
  }, []);

  // handleScrollToSection
  const handleScrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // ModeArticle content
  const ModeArticle = mode.map((mode) => {
    const modeAffichage = modesReglesData.filter((data) => data.mode === mode);
    if (modeAffichage.length === 0) return null;
    return (
      <article
        className="reglesContent__article"
        key={mode}
        id={`sectionCible-${mode}`}
      >
        <h2
          className={`text-special ${
            mode === "Expert" ? "text-special--red red" : "blue"
          }`}
        >
          {`${mode === "Entraînement" ? mode : `Mode ${mode}`}`}
        </h2>

        <ReactMarkdown
          components={{
            p: ({ ...props }) => (
              <p
                className={`text-page-semib paragraph--${
                  mode === "Expert" ? "red" : "blue"
                }`}
                {...props}
              />
            ),
          }}
        >
          {modeAffichage[0].descript}
        </ReactMarkdown>

        <h3
          className={`text-page-bold text-page-bold-small--${
            mode === "Expert" ? "red" : "blue"
          }`}
        >
          Déroulement du Jeu
        </h3>
        <ol
          className="questionsText--alignLeft text-page-light--black"
          type="A"
        >
          {modeAffichage[0].instructions.map((instruction, index) => (
            <li className="text-page-light" key={`${instruction}--${index}`}>
              {instruction}
            </li>
          ))}
        </ol>

        <h3
          className={`text-page-bold-small text-page-bold-small--${
            mode === "Expert" ? "red" : "blue"
          }`}
        >
          Thématiques disponibles
          <ul className="reglesContent__themesList">
            {generalReglesData[0].thematiques.map((theme, index) => {
              return (
                <li className="text-page-light" key={`${theme}--${index}`}>
                  {theme}
                </li>
              );
            })}
          </ul>
        </h3>

        <h3
          className={`text-page-bold-small text-page-bold-small--${
            mode === "Expert" ? "red" : "blue"
          }`}
        >
          Difficulté et système de points
        </h3>
        <ul className="text-page-semib text-page-semib--blackSmall">
          {Object.entries(generalReglesData[0].points).map(
            ([point, description], index) => (
              <li
                className="text-page-semib text-page-semib--blackSmall"
                key={index}
              >
                {`Difficulté ${point} = `}
                <span className="text-page-light text-page-light--blackSmall">{`${point} point${
                  index > 0 ? "s" : ""
                } `}</span>
                <p className="text-page-light">{description}</p>
              </li>
            )
          )}
        </ul>

        <h3
          className={`text-page-bold-small text-page-bold-small--${
            mode === "Expert" ? "red" : "blue"
          }`}
        >
          Fin du jeu
        </h3>
        <p className="text-page-semib">Joueur Solo</p>
        <ReactMarkdown
          components={{
            p: ({ ...props }) => (
              <p
                className={`text-page-light  paragraph--${
                  mode === "Expert" ? "red" : "blue"
                }`}
                {...props}
              />
            ),
          }}
        >
          {modeAffichage[0].fin.solo}
        </ReactMarkdown>
        {modeAffichage[0].fin.multi && (
          <>
            <p className="text-page-semib">Multijoueur</p>
            <ReactMarkdown
              components={{
                p: ({ ...props }) => (
                  <p
                    className={`text-page-light  paragraph--${
                      mode === "Expert" ? "red" : "blue"
                    }`}
                    {...props}
                  />
                ),
              }}
            >
              {modeAffichage[0].fin.multi}
            </ReactMarkdown>
          </>
        )}
      </article>
    );
  });

  return (
    <Container color="white">
      <section className="reglesContent" id="reglesTitle">
        <h1 className="text-special text-special--red">Règles du jeu</h1>
        <ul className="text-page-light reglesContent__link">
          <li
            className="text-page-light--blackSmall"
            onClick={() => handleScrollToSection(`sectionCible-Entraînement`)}
          >
            Entraînement
          </li>
          <li
            className="text-page-light--blackSmall"
            onClick={() => handleScrollToSection(`sectionCible-Classique`)}
          >
            <a href="#/accueil/regles#sectionCible-Classique">Mode classique</a>
          </li>
          <li
            className="text-page-light--blackSmall"
            onClick={() => handleScrollToSection(`sectionCible-Expert`)}
          >
            <a href="#/accueil/regles#sectionCible-Expert">Mode expert</a>
          </li>
        </ul>

        {ModeArticle}

        {/* {showScrollButton && ( */}
        <ScrollToTop sectionId="reglesTitle" />
        {/* )} */}
      </section>
    </Container>
  );
}

export default Regles;
